module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/page-view/page-view.component.html
// module id = ../../../../../src/app/core/components/page-view/page-view.component.html
// module chunks = main